import SystemDataSetup from "../../components/systemDataInitialization/SystemDataSetup";


const Products=()=>{

  return <>
  <SystemDataSetup />
  </>
}

export default Products;